// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"modal-title--2gsfBYvN"};